import React from 'react'
import ReactDOM from 'react-dom/client'

import ListEvents from '../../app/views/events/list.jsx'
import ParticipantSignup from '../../app/views/event-registration/signup-main.jsx'
import EventOverview from '../../app/views/events/overview.jsx'
import NewEvent from "../../app/views/new-event/new-event.jsx";

// Alle möglichen Mount-Punkte prüfen
const targets = [
    { id: 'list-events', component: <ListEvents /> },
    { id: 'participant-signup', component: <ParticipantSignup /> },
    { id: 'event-details', component: <EventOverview /> },
    { id: 'new-event', component: <NewEvent />}

    //{ id: 'people-root', component: <PeopleApp /> },
    //{ id: 'contact-root', component: <ContactApp /> },
]

// Durchgehen und passende App mounten
targets.forEach(({ id, component }) => {
    const el = document.getElementById(id)
    if (el) {
        ReactDOM.createRoot(el).render(component)
    }
})
